/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * События уведомлений
 */

/**
 * Задача на отправку уведомления.
 * Очередь key.bell.send_push_notification
 */
export type SendPushNotificationTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * ОРПОН
   */
  orpon: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Заголовок уведомления
   */
  header: string
  /**
   * Текст уведомления
   */
  text: string
  /**
   * Полезная нагрузка
   */
  payload?: {[key:string]:string}
}
/**
 * Задача на отправку уведомления.
 * Очередь key.bell.send_push_notification
 */
export type SendPushNotificationTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * ОРПОН
   */
  orpon: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Заголовок уведомления
   */
  header: string
  /**
   * Текст уведомления
   */
  text: string
  /**
   * Полезная нагрузка
   */
  payload: {[key:string]:string}
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Задача на отправку уведомления.
   * Очередь key.bell.send_push_notification
   */
  "SendPushNotificationTask": {
    "kind": "class",
    "text": "Задача на отправку уведомления.\nОчередь key.bell.send_push_notification",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОН
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Заголовок уведомления
       */
      "header": {
        "type": "string",
        "text": "Заголовок уведомления",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Текст уведомления
       */
      "text": {
        "type": "string",
        "text": "Текст уведомления",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Полезная нагрузка
       */
      "payload": {
        "type": "{[key:string]:string}",
        "text": "Полезная нагрузка",
      },
    },
  },
}